import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

class PlansSlider extends HTMLElement {
  constructor() {
    super();

    this.toggle = this.querySelector('[data-plan-toggle]');

    const { slideCount } = this.dataset;
    const showSliderUI = slideCount > 3;

    this.swiper = new Swiper(this.querySelector('.swiper'), {
      spaceBetween: 10,
      modules: [Navigation],
      slidesPerView: 'auto',
      centeredSlides: true,
      breakpoints: {
        1024: {
          centerInsufficientSlides: true,
          slidesPerView: showSliderUI ? Math.min(4, slideCount) : 'auto',
          centeredSlides: false,
          navigation: {
            enabled: showSliderUI,
            nextEl: this.querySelector('.swiper-button-next'),
            prevEl: this.querySelector('.swiper-button-prev'),
          },
        },
        768: {
          slidesPerView: 'auto',
          centeredSlides: false,
          slidesOffsetBefore: 25,
          slidesOffsetAfter: 25,
        },
      },
    });

    if (this.toggle) {
      this.toggle.addEventListener('change', (e) => {
        this.swiper.slideTo(e.target.value, 500);
      });

      this.swiper.on('activeIndexChange', () => {
        this.toggle.querySelector(`[value="${this.swiper.activeIndex}"]`).checked = true;
      });
    }
  }
}

customElements.define('plans-slider', PlansSlider);
